function initAnimations() {
    const items = document.querySelectorAll(".anim");
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
            if(entry.isIntersecting){
                entry.target.classList.add("show");
                observer.unobserve(entry.target);
            }
        });
    },{
        threshold:.15,
        rootMargin:"0px 0px -80px 0px"
    });
    items.forEach(item=>observer.observe(item));

}
document.addEventListener("DOMContentLoaded", initAnimations);
document.addEventListener("shopify:section:load", initAnimations);